const createWishlist = () =>
  new Vue({
    data: () => {
      return {
        sortList: [
          {
            label: "Comprehensive",
            value: 3,
          },
          {
            label: "New Arrivals",
            value: 0,
          },
          {
            label: "Price Low to High",
            value: 1,
          },
          {
            label: "Price High to Low",
            value: 2,
          },
        ],
        listData: [],
        variantList: [],
        sectionId: "",
        showSortFlag: false,
        activeIndex: 0,
        nodata: false,
        page: 1,
        size: 60,
        total: 0,
        inputValue: 1,
        searchVal: "",
        currencyCode: "USD",
        currencySymbol: "$",
        isLoading: false,
        productAdapter: new ProductApi(),
      };
    },
    created() {
      // const wishEle = document.querySelector("#wish");
      // this.sectionId = wishEle ? wishEle?.dataset?.sectionId : "";
      const jsonString = theme.getCookies("userSelected");
      const userSelected = theme.inspectJson(jsonString);
      this.currencyCode = userSelected?.currency_code || "USD";
      this.currencySymbol = decodeURIComponent(
        userSelected?.currency_symbol ?? "US$"
      );
      this.init();
    },
    computed: {
      totalPages() {
        return Math.ceil(this.total / this.size);
      },
      // 是否显示左省略号
      showLeftEllipsis() {
        return this.totalPages > 7 && this.page > 4;
      },
      // 是否显示右省略号
      showRightEllipsis() {
        return this.totalPages > 7 && this.page < this.totalPages - 3;
      },
      // 中间显示的页码
      middlePages() {
        const pages = [];
        if (this.totalPages <= 7) {
          // 总页数小于等于7，显示所有页码
          for (let i = 2; i < this.totalPages; i++) {
            pages.push(i);
          }
        } else {
          let start, end;

          if (this.page <= 4) {
            // 当前页靠近开始
            start = 2;
            end = 7;
          } else if (this.page >= this.totalPages - 3) {
            // 当前页靠近结束
            start = this.totalPages - 6;
            end = this.totalPages - 1;
          } else {
            // 当前页在中间
            start = this.page - 2;
            end = this.page + 2;
          }

          for (let i = start; i <= end; i++) {
            pages.push(i);
          }
        }
        return pages;
      },
    },
    methods: {
      init() {
        this.listData = [];
        this.nodata = false;
        this.getList();
      },
      async getList() {
        const params = {
          page: this.page,
          size: this.size,
          sort: this.sortList[this.activeIndex].value,
        };
        this.isLoading = true;
        const response = await this.productAdapter.getWish(
          params,
          "formAccount"
        );
        if (response) {
          this.listData = response.products;
          this.variantList = response?.variants;
          this.total = response?.total;
          this.nodata = this.total == 0 ? true : false;
        }
        this.isLoading = false;
      },
      selectSort(index) {
        this.activeIndex = index;
        document.querySelector("#selectedSort").innerHTML =
          this.sortList[this.activeIndex].label;
        this.page = 1;
        this.size = 60;
        this.getList();
      },
      formatPrice(item) {
        if (item.max_price == item.min_price) {
          return `${theme.formatPrice(
            theme.convertCurrency(item.max_price, "usdToSet")
          )}`;
        } else {
          return `${theme.formatPrice(
            theme.convertCurrency(item.min_price, "usdToSet")
          )} - ${theme.formatPrice(
            theme.convertCurrency(item.max_price, "usdToSet"),
            false
          )}`;
        }
      },
      // 获取不同类型的id
      getIdStr(name, id) {
        return `${name}-${this.sectionId}-${id}`;
      },
      // 返回产品url
      productUrl(item) {
        return `/products/${item?.handle}`;
      },
      // 修改产品主图显示
      changeFeaturedImg(variant, item) {
        item.featured_image = variant.feature_image;
        this.$set(variant, "active", true);
      },
      //
      leaveImg(variant) {
        this.$set(variant, "active", false);
      },
      prevPage() {
        if (this.page > 1) {
          this.page--;
          this.inputValue = this.page;
          this.getList();
        }
      },
      nextPage() {
        if (this.page < this.totalPages) {
          this.page++;
          this.inputValue = this.page;
          this.getList();
        }
      },
      goToPage(pageNumber) {
        let number = Number(pageNumber);
        if (number > this.totalPages) {
          number = this.totalPages;
        }
        if (number < 1) {
          number = 1;
        }
        this.inputValue = number;
        this.page = number;
        this.getList();
      },
      async deleteItem(id) {
        const params = {
          page: this.page,
          size: this.size,
          favorite: false,
          echo: true,
          sort: this.sortList[this.activeIndex].value,
        };
        this.isLoading = true;
        const response = await this.productAdapter.cancelWish(
          [id],
          params,
          "formAccount"
        );
        if (response) {
          this.listData = response.products;
          this.variantList = response?.variants;
          this.total = response?.total;
          this.nodata = this.total == 0 ? true : false;
        }
        this.isLoading = false;
      },
      deleteLocal(id) {
        var wishData = JSON.parse(localStorage.getItem("wishList"));
        let newList = wishData?.filter((item) => item != id);
        localStorage.setItem("wishList", JSON.stringify([...new Set(newList)]));
      },
    },
    template: `
  <div class="content-list right-content hidden" id="my-wishlist">
    <div class="flex justify-space-between font-size-20 font-bold">
      <div>My Wishlist</div>
    </div>
    <div class="flex">
      <div class="sort-content" @click="showSortFlag=!showSortFlag">
        <div class="flex align-items-center justify-space-between">
          <div>
            <span class="active margin-left-20" id="selectedSort">{{ sortList[activeIndex].label }}</span>
          </div>
          <img class="arrow arrow-dn" v-if="!showSortFlag" src="https://assets.gooddiy.com/image/arrow_dn.png">
          <img class="arrow arrow-up" v-else="showSortFlag" src="https://assets.gooddiy.com/image/arrow_up.png">
        </div>
        <div class="sort-item" v-show="showSortFlag"> 
          <div class="flex justify-space-between align-items-center" :class="activeIndex==index? 'active' : ''" v-for="(item, index) in sortList" @click="selectSort(index)">
            <span>{{ item.label }}</span>
            <img v-if="activeIndex==index" class="right" src="https://assets.gooddiy.com/image/right.png">
          </div>
        </div>
      </div>
    </div>
    <div class="grid grid--5-col-desktop product-list" v-if="!nodata">
      <div class="grid-item" v-for="item in listData">
        <div class="relative">
          <a class="basic-image" :href="productUrl(item)" target="_blank">
            <img class="" :src="item.featured_image + '?width=370'">
          </a>
          <div class="float-remove-item" @click.stop="deleteItem(item.id)">
            Remove item
          </div>
        </div>
        <div class="relative">
          <wb-card-variant>
            <div class="wbproductdes">
              <product-info :id="getIdStr('ProductInfo',item.id)" :data-section-input="sectionId" :data-section="sectionId" data-layout="card" :data-url="productUrl(item)">
                <div class="card__information">
                  <h2 class="cardhide_toggle card__heading overflow_text h5" :id="getIdStr('title',item.id)">
                    <a :href="productUrl(item)" :id="getIdStr('CardLink',item.id)" class="full-unstyled-link" target="_blank">
                      {{ item.title}}
                    </a>
                  </h2>
                  <div class="card-information">
                    <div class="no-js-hidden wbhprice" :id="getIdStr('price',item.id)" role="status">
                      <div class="card_product_Price">
                        <span class="card_sale_price price notranslate">
                          {{ formatPrice(item) }}
                        </span>
                      </div>
                    </div>
                  
                    <div class="flex wuyuwuwwd">
                      <div class="flex wb_select_btnaa1 align-items-center">
                        <card-m-varirimg v-for="varir in variantList[item.id]" @mouseenter="changeFeaturedImg(varir, item)" @mouseleave="leaveImg(varir)">
                          <div class="card-m-varirimg" :class="varir.active ? 'active': ''" data-section="template--18313698181350__hot_product_HbNtUY" :data-product="varir.product_id" :data-featured_media="varir.id">
                            <img :src="varir.feature_image + '?width=66'">
                          </div>
                        </card-m-varirimg>
                        <div v-if="item.variants_count>3" class="color-666">...</div>
                      </div>
                      <div class="flex align-center">
                        <div class="wb_select_btnaa1">
                          <modal-opener data-modal="#QuickAdd" class="relative">
                            <button :id="getIdStr('quick-add',item.id)" type="submit" name="add" class="wb_select_btn1 link underlined-link quick-add__submit button--full-width" aria-haspopup="dialog"  :data-product-url="productUrl(item)" :data-product-id="item.id" data-gpo-collection-item-handle="fashion-national-flag-stainless-steel-necklace-dripping-oil-stainless-steel-necklaces-2">
                              <span class="hidden">
                                <svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false" class="icon icon-plus" fill="none" viewBox="0 0 10 10">
                                  <path fill-rule="evenodd" clip-rule="evenodd" d="M1 4.51a.5.5 0 000 1h3.5l.01 3.5a.5.5 0 001-.01V5.5l3.5-.01a.5.5 0 00-.01-1H5.5L5.49.99a.5.5 0 00-1 .01v3.5l-3.5.01H1z" fill="currentColor"></path>
                                </svg>
                                Select options
                              </span>
                              <div>
                                <img class="cart-img heratPop" src="https://cdn.shopify.com/s/files/1/0574/9807/5287/files/new-shopping-cart-af002be6.png?v=1716603513">
                              </div>
                              <div class="loading-overlay__spinner hidden">
                                <svg aria-hidden="true" focusable="false" class="spinner" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg">
                                  <circle class="path" fill="none" stroke-width="6" cx="33" cy="33" r="30"></circle>
                                </svg>
                              </div>
                            </button>
                            <span class="add-cart-count" :class="item.cartCount>0 ? '' : 'hidden'" :data-id="item.id">{{ item.cartCount > 99 ? '99+' : item.cartCount }}</span>
                          </modal-opener>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </product-info>
            </div>
          </wb-card-variant>
        </div>
      </div>
    </div>
    <div class="pagenation justify-content-center flex" v-if="!nodata">
      <div class="pagenation-btn flex align-items-center justify-content-center border-radius-2 cursor-pointer" @click="prevPage" :disabled="page === 1">
        <img class="pagenation-arrow arrow-left" src="https://assets.gooddiy.com/image/arrow_up.png">
      </div>
      <div class="pagenation-item border-radius-2 notranslate" :class="page==1 ? 'active' : ''" @click="goToPage(1)">1</div>
      <div v-if="showLeftEllipsis" class="notranslate">...</div>
      <div class="pagenation-item border-radius-2 notranslate" :class="pageNumber==page? 'active' : ''" v-for="pageNumber in middlePages" :key="pageNumber" @click="goToPage(pageNumber)">{{ pageNumber }}</div>

      <div v-if="showRightEllipsis" class="notranslate">...</div>
      <div v-if="totalPages > 1" class="pagenation-item border-radius-2 notranslate" :class="page==totalPages ? 'active' : ''" @click="goToPage(totalPages)">{{ totalPages }}</div>
      <div class="pagenation-btn flex align-items-center justify-content-center border-radius-2 cursor-pointer" @click="nextPage" :disabled="page === totalPages">
        <img class="pagenation-arrow arrow-right" src="https://assets.gooddiy.com/image/arrow_up.png">
      </div>
    </div>
    <div class="mask" v-if="isLoading"></div>
    <div class="flex justify-content-center align-items-center no-data product-list" v-if="nodata">
      <div>
        <img src="https://assets.gooddiy.com/image/no-data.png">
      </div>
    </div>
  </div>`,
  });

let wishlist = null;
